<script>
  import { userStore } from "../../stores/user.store.js";

  import { getMap, pointTo, panTo } from "../../helpers/map";
  import { runWatch, odstranVrstvuZMapy, onClick } from "./sidebarManager.func";
  import { vratKodFarbyPodlaTypu } from "../../helpers/config";

  const map = getMap();
  let data = [];

  map.on("load", () => {
    // potrebujem sledovat zmenu ulozenych dat uzivatela
    // ked vlozim vrstvu, ulozi sa to do pamate a to zachytim
    // a potom viem pracovat s navigacnym okienkom
    let unsubscribeUserData = userStore.subscribe((currentValue) => {
      //currentValue == $comparedProducts
      data = runWatch(currentValue);
    });
  });
</script>

{#if data && Object.keys(data).length}
  <!-- Side manager start  -->
  <div class="side-manager">
    <ul>
      {#each Object.entries(data) as [source_id, layer]}
        <li>
          <span on:click={panTo(layer.sourceData, layer.typ_vrstvy)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 17.999 18.005"
              class="icon"
            >
              <path
                d="M1,18.554,5.976,13.68A7.045,7.045,0,0,1,4.343,9.172,7.26,7.26,0,0,1,11.672,2,7.259,7.259,0,0,1,19,9.172a7.259,7.259,0,0,1-7.328,7.172,7.4,7.4,0,0,1-4.158-1.269l-5.032,4.93ZM6.438,9.187a5.252,5.252,0,0,0,10.5,0,5.252,5.252,0,0,0-10.5,0Z"
                transform="translate(-1.001 -2)"
                fill="currentColor"
              />
            </svg>
          </span>
          <span on:click={pointTo(layer.sourceData, layer.typ_vrstvy)}>
            <!-- JSON icon location start -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
              viewBox="0 0 370.854 511.999"
              fill="currentColor"
            >
              <g transform="translate(-70.573)">
                <g>
                  <path
                    d="M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173,321.035a16.7,16.7,0,0,0,24.846,0c7.065-7.868,173-194.147,173-321.035C441.425,83.182,358.244,0,256,0Zm0,278.719a93.292,93.292,0,1,1,93.291-93.292A93.4,93.4,0,0,1,256,278.719Z"
                  />
                </g>
              </g>
            </svg>
            <!-- JSON icon location end -->
          </span>

          <span
            on:click={onClick(layer)}
            class="color__text--{vratKodFarbyPodlaTypu(
              layer.data.typ || layer.data.gistyp
            )}"
            title={layer.data.typ}
            >{layer.data.title || layer.data.nazov || layer.data.value}</span
          >

          <span on:click={odstranVrstvuZMapy(source_id)}>
            <!-- JSON icon Close start -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
              viewBox="0 0 329.27 329.263"
            >
              <g transform="translate(0 -0.135)">
                <path
                  d="M21.34,329.4A21.332,21.332,0,0,1,6.258,292.984L292.848,6.39a21.329,21.329,0,0,1,30.164,30.164L36.422,323.148A21.231,21.231,0,0,1,21.34,329.4Zm0,0"
                  fill="#ff8d8d"
                />
                <path
                  d="M307.93,329.4a21.273,21.273,0,0,1-15.082-6.25L6.258,36.554A21.329,21.329,0,0,1,36.422,6.39l286.59,286.594A21.332,21.332,0,0,1,307.93,329.4Zm0,0"
                  fill="#ff8d8d"
                />
              </g>
            </svg>
            <!-- JSON icon Close end -->
          </span>
        </li>
      {/each}
    </ul>
  </div>
  <!-- Side manager end  -->
{/if}

<style>
  .side-manager ul li span:last-child {
    margin-left: auto;
  }
</style>
